/**
 * Editor action handlers (rotate, error, export)
 */

import type { dia } from '@joint/core'
import type { EditorModalState } from '../types'
import { log, LogCategory } from '../../../../../map-editor-shared/lib/logger'

export function handleRotateFn(
  setRotation: React.Dispatch<React.SetStateAction<number>>
) {
  setRotation(prev => (prev + 90) % 360)
}

export function handleErrorFn(
  setModalState: React.Dispatch<React.SetStateAction<EditorModalState>>,
  error: Error
) {
  setModalState((prev) => ({ ...prev, error: { show: true, message: error.message } }))
}

export function handleExportFn(params: {
  currentFloor: string | null
  graph: dia.Graph | null
  updateFloorMapData: (floor: string, data: any) => void
  setModalState: React.Dispatch<React.SetStateAction<EditorModalState>>
}) {
  const { currentFloor, graph, updateFloorMapData, setModalState } = params

  // Save current floor's graph data to store before opening export modal
  // This ensures all floors have the latest data for multi-floor export
  if (currentFloor && graph) {
    const graphJson = graph.toJSON()
    updateFloorMapData(currentFloor, { graphJson })
    log.info(LogCategory.FLOOR, `Saved current floor ${currentFloor} graph data before export`)
  }
  setModalState((prev) => ({ ...prev, export: true }))
}
